// import Constants from '@/js/utils/constants';
// import axios from "axios-https-proxy-fix";
// let urls = {
//     filters: Constants.BASE_URL + '/filters',
//     code_info: Constants.BASE_URL + '/code_info',
//     sign_url: Constants.BASE_URL + '/sign_url',
//     events: Constants.TRACKEVENT_BASE_URL + '/data/v2/track-views',
// }

let CommonSrv = {
    trackEvent: function () {
        // var timestamp = new Date().valueOf();
        // body['client_time'] = timestamp;
        // let usrId = body.user_id;
        // if (!usrId) {
        //     body['user_id'] = "";
        // }
        // const proxy = {
        //     host: Constants.TRACKEVENT_BASE_URL,
        //     port: 443
        // };
        // let params = {
        //     method: "post",
        //     url: urls.events,
        //     data: { "type": 1, "project_type": 2, "data": body },
        //     proxy: proxy,
        //     withCredentials: false
        // };
        // return axios(params);
    }
};
export default CommonSrv;


// WEBPACK FOOTER //
// ./src/js/utils/common-service.js